import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const FinanceListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {id} = useParams();
  const [finances, setFinances] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [project, setProject] = useState(null);
  const [costTypes, setCostTypes] = useState([]);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    if (!project) return;
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      const costCenterId = project?.cost_center?.id ?? project?.cost_center_id ?? null;
      let query = window.App.transformQueryParams(lazyParams)
      const extraFilter = `&search[cost_center][operator]==&search[cost_center][value]=${encodeURIComponent(costCenterId)}`;
      apiCall('get', `/api/v2/cost-allocation` + query + extraFilter, {})
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setFinances(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
        
      apiCall('get', '/api/v2/cost-type?' + JSON.stringify({
        first: 0,
        rows: 9999,
        page: 0,
      }))
        .then(response => {
          setCostTypes(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const costTypeFilterTemplate = (options) => (
    <Dropdown
      value={options.value}
      options={costTypes}
      optionLabel="name"
      optionValue="id"
      placeholder={t('all')}onChange={(e) => options.filterApplyCallback(e.value)}
      appendTo={document.body}
    />
  );

  const renderCurrencyTotals = (totalsMap) => {
    if (!totalsMap || totalsMap.size === 0) return null;
    const priority = ['HUF', 'EUR'];
    const entries = Array.from(totalsMap.entries()).sort(([a], [b]) => {
      const ai = priority.indexOf(a);
      const bi = priority.indexOf(b);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return String(a).localeCompare(String(b));
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-end' }}>
        {entries.map(([currency, sum]) => (
          <div key={currency} style={{ whiteSpace: 'nowrap' }}>
            {(window?.App?.currencyFormatter
              ? window.App.currencyFormatter(currency, sum)
              : `${sum} ${currency}`)}
          </div>
        ))}
      </div>
    );
  };

  const totalsByCurrency = React.useMemo(() => {
    const map = new Map();
    (finances || []).forEach(row => {
      const currency = row?.currency || 'HUF';
      const amount = Number(row?.amount);
      if (Number.isFinite(amount)) {
        map.set(currency, (map.get(currency) || 0) + amount);
      }
    });
    return map;
  }, [finances]);

  const amountFooter = React.useMemo(() => {
    return renderCurrencyTotals(totalsByCurrency);
  }, [totalsByCurrency]);

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {rowData?.receipt?.id && (
          <Button
            icon="pi pi-eye"
            className="p-button"
            tooltip={t('receiptView')}
            tooltipOptions={{position: 'left'}}
            onClick={() => {
              history.push('/finance/receipt/read/' + rowData.receipt.id);
            }}
          />
        )}
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'finance') {
                      history.push('/project/project/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/cost-allocation/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderFinanceList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    apiCall('get', '/api/v2/project/' + id, {})
      .then(response => setProject(response.data.data))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    loadLazyData();
  }, [project, lazyParams, window.App.state.rerenderFinanceList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={finances} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column header={t('columnName')} sortable filter filterField='cost_item_name'
          body={(row) => row?.cost_item?.name || ''}
        />
        <Column header={t('columnCostType')} sortable filter filterField='cost_type' filterMatchMode='equals' filterElement={costTypeFilterTemplate}
          body={(row) => row?.cost_type?.name || '' }
        />
        <Column header={t('columnCostSource')}
          body={(row) => {
            const source = row?.cost_item?.source;
            return source ? t(`costSource${source}`) : '';
          }}
        />

        <Column header={t('columnDocument')} sortable
          body={(row) => row?.receipt?.receipt_number || '' }
        />

        <Column header={t('columnAllocatedAmount')} sortable
          body={(row) => {
            const amount = row?.amount;
            const currency = row?.currency;
            const num = Number(amount);
            if (amount === null || amount === undefined || Number.isNaN(num)) return <></>;
            return <>{window.App.currencyFormatter(currency, num)}</>;
          }}
          className={"p-text-right p-text-nowrap"}
          alignHeader="right"
          footer={amountFooter}
          footerStyle={{ textAlign: 'right', fontWeight: 600 }}
        />

        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(FinanceListComponent);
